import { useGamesWithCategories } from './useGamesWithCategories'

interface Props {
  slug: string
}

export default function useGame({ slug }: Props) {
  return useGamesWithCategories({ select: ({ games }) => games[slug] })
}
